import React from "react";
import { useStytch, useStytchSession, useStytchUser } from "@stytch/react";
import { useEffect } from "react";

export const UserContext = React.createContext({});

// Fonction utilitaire pour lire les cookies
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

/*
During both the Magic link and OAuth flow, Stytch will redirect the user back to your application to a specified redirect URL (see Login.js).
Stytch will append query parameters to the redirect URL which are then used to complete the authentication flow.
A redirect URL for this example app will look something like: http://localhost:3000/?stytch_token_type=magic_links&token=abc123

TokenAuthenticator will detect the presence of a token in the query parameters, and attempt to authenticate it.
On successful authentication, a session will be created and the user will be shown Profile.js
*/
const TokenAuthenticator = ({ children }) => {
  const stytch = useStytch();
  const { user } = useStytchUser();
  const { session } = useStytchSession();
  const token = getCookie('stytch_session');

  useEffect(() => {
    if (!stytch || user) return;

    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("token");
    const tokenType = queryParams.get("stytch_token_type");

    // If a token is found, authenticate it with the appropriate method
    try {
      if (token && tokenType) {
        if (tokenType === "magic_links") {
        stytch.magicLinks.authenticate(token, {
          session_duration_minutes: 60,
        });
      } else if (tokenType === "oauth") {
        stytch.oauth.authenticate(token, {
          session_duration_minutes: 60,
        });
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      // Clear the token from the query params
      queryParams.delete("token");
      queryParams.delete("stytch_token_type");
      window.history.replaceState({}, document.title, window.location.pathname);
    }

  }, [stytch, user]);

  return (
    <UserContext.Provider value={{ user, session, token }}>
      {children}
    </UserContext.Provider>
  );
};

export default TokenAuthenticator;